import { Injectable } from '@angular/core'
import { switchMap } from 'rxjs/operators'
import { PrintDialogComponent, PrintDialogData } from '@app/shared/dialogs/print-dialog/print-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { Observable, of } from 'rxjs'
import { PrintData } from '@app/shared/models/print.model'
import { PrintHttpService } from './print.http.service'

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  constructor(
    private dialog: MatDialog,
    private printHttpService: PrintHttpService,
  ) {}

  openDialog(projectId: string, ahuId?: string): Observable<Blob> {
    const dialogRef = this.dialog.open<PrintDialogComponent, PrintDialogData, { fileName: string; data: PrintData }>(PrintDialogComponent, {
      data: {
        projectId,
        ahuId,
      } as PrintDialogData,
      minHeight: '480px',
      height: 'auto',
      minWidth: '500px',
      maxWidth: '1200px',
    })

    return dialogRef.afterClosed().pipe(
      switchMap((result: { fileName: string; data: PrintData }) => {
        if (!result) {
          return of(null)
        }
        return this.printHttpService.printDocument(projectId, result.fileName, result.data)
      }),
    )
  }
}
